import { get, post } from 'utils/api';

export const sendContactEmail = (data) => {
  return post(`/util/sendemail`, data);
};

export const generateConsolidatedInvoice = () => {
  return get(`/util/generate_bulk_invoice_fleet`);
};

export const retryGeneratingInvoices = (data) => {
  return post(`/util/einvoicecron?tenant=:tenantId`, data);
};

export const util = {
  sendContactEmail,
  generateConsolidatedInvoice,
  retryGeneratingInvoices,
};
